import Category from './Category';

export default class Navigation {
  constructor(pluginConfig) {
    const rootCategories = pluginConfig.rootCategories || [];
    this.isNavigationCategories = pluginConfig.frameConfig?.navigation_categories?.length;
    this.data = rootCategories.map((category) => new Category(category));
  }

  get precedence() {
    // "Editors Picks" -1
    // "Live Music" 16
    // "Nightlife" 17
    // "Kids & Family" 14
    // "Festivals" 6
    // "Sports & Leisure, 22
    return [-1, 16, 17, 14, 6, 22];
  }

  get categories() {
    if (this.isNavigationCategories) {
      return [...new Set(this.data)];
    }

    const precedenceCategories = this.precedence
      .map((catId) => this.data.find((category) => category.id === catId))
      .filter(Boolean);

    // return precendence first, then alphabetically,  then ensure uniqueness.
    return [
      ...new Set(
        precedenceCategories.concat(this.data.sort((a, b) => a.name.localeCompare(b.name)))
      ),
    ];
  }

  get alphaCategories() {
    return this.data.sort((a, b) => a.name.localeCompare(b.name));
  }

  lookupBySlug(slug) {
    return this.data.find((category) => category.slug === slug);
  }

  selectedCategory(router) {
    if (!router.pathname) {
      return null;
    }

    if (router.pathname === '/' || router.asPath.split('/').length === 3) {
      return null;
    }

    return this.data.find((category) => router.asPath.split('?')[0].endsWith(category.slug));
  }
}
